import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
type BreadcrumbItem = {
  label: string;
  route?: string;
}

@Component({
  selector: 'app-validation-section-header',
  templateUrl: './validation-section-header.component.html',
  styleUrls: ['./validation-section-header.component.scss']
})
export class ValidationSectionHeaderComponent implements OnInit {


  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() breadcrumbs: BreadcrumbItem[] = [];


  @Input() showLogo: boolean = true;

  @Input() homeRoute = '/validation';
  @Input() showMainMenuButton: boolean = false;



  constructor() { }

  ngOnInit(): void {
  }
}
